import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const CheckList = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.1355 3.41146H5.0625C5.47671 3.41146 5.8125 3.07567 5.8125 2.66146C5.8125 2.24725 5.47671 1.91146 5.0625 1.91146H2.8855C2.19514 1.91146 1.6355 2.4711 1.6355 3.16146V8.22396C1.6355 8.91432 2.19514 9.47396 2.8855 9.47396H7.948C8.63835 9.47396 9.198 8.91432 9.198 8.22396V6.19271C9.198 5.7785 8.86221 5.44271 8.448 5.44271C8.03378 5.44271 7.698 5.7785 7.698 6.19271V7.97396H3.1355V3.41146ZM8.41733 3.43396C8.63686 3.08271 8.53008 2.61999 8.17883 2.40046C7.82758 2.18093 7.36487 2.28771 7.14533 2.63896L5.56168 5.17281L4.97833 4.58946C4.68543 4.29657 4.21056 4.29657 3.91767 4.58946C3.62477 4.88236 3.62477 5.35723 3.91767 5.65012L5.16767 6.90012C5.32928 7.06174 5.55577 7.14084 5.78287 7.11498C6.00996 7.08911 6.21286 6.96111 6.334 6.76729L8.41733 3.43396ZM18.0833 6.44271L11 6.44271C10.5858 6.44271 10.25 6.10692 10.25 5.69271C10.25 5.2785 10.5858 4.94271 11 4.94271L18.0833 4.94271C18.4975 4.94271 18.8333 5.2785 18.8333 5.69271C18.8333 6.10692 18.4975 6.44271 18.0833 6.44271ZM18.0833 15.599H11C10.5858 15.599 10.25 15.2632 10.25 14.849C10.25 14.4347 10.5858 14.099 11 14.099H18.0833C18.4975 14.099 18.8333 14.4347 18.8333 14.849C18.8333 15.2632 18.4975 15.599 18.0833 15.599ZM3.20874 17.0571V12.641H7.62492V17.0571H3.20874ZM1.70874 12.141C1.70874 11.5887 2.15646 11.141 2.70874 11.141H8.12492C8.6772 11.141 9.12492 11.5887 9.12492 12.141V17.5571C9.12492 18.1094 8.6772 18.5571 8.12492 18.5571H2.70874C2.15645 18.5571 1.70874 18.1094 1.70874 17.5571V12.141Z"
        fill={color}
      />
    </svg>
  )
})

export default CheckList
